/**********************************************************************
 * Common Software Utilities
 *********************************************************************/

const SoftwareUtils = {
    /**
     * Get contentId based on the location.hash.
     */
    getCurrentContentId: function() {
        let currentContentId = null;
        
        if (location.hash) {
            const hashParts = location.hash.substring(1).split('/');
            if (hashParts.length>=2) {
                currentContentId = 'content-' + hashParts[0] + '-' + hashParts[1];
            } else {
                console.error('SoftwareUtils.getCurrentContentId(): Unable to determine the currentContentId due to incorrect location.hash.');
            }
        }
        
        return currentContentId;
    },
    
    /* Create element cache. */
    createChildrenCache: function(cacheElementNames) {
        const contentId = SoftwareUtils.getCurrentContentId();
        let cacheElements = null;
        
        if (cacheElementNames && contentId) {
            const contentElement = document.getElementById(contentId);
            if (contentElement) {
                cacheElements = {};
                
                var elementNamesForEachHandler = function(elementName) {
                    if (!cacheElements[elementName]) {
                        const elements = contentElement.getElementsByClassName(elementName);
                        if (elements && elements.length>0) {
                            cacheElements[elementName] = elements[0];
                        }
                    }
                }
                cacheElementNames.forEach(elementNamesForEachHandler.bind(this));
            }
            
            console.debug(`SoftwareUtils.createChildrenCache(): contentId: ${contentId}\ncacheElements: `);
            console.debug(cacheElements);
        } else {
            console.warn(`SoftwareUtils.creteChildrenCache(): Cannot create children cache due to missing elementNames or undertermined contentId.`);
        }
        
        return cacheElements;
    }, 
    
    getFormSubmitButton: function(formElement) {
        if (formElement) {
            for (let i=formElement.length-1;i>=0;i--) {
                if (formElement[i].tagName==='INPUT' && formElement[i].type==='submit') {
                    return formElement[i];
                }
            }
        }
        
        return null;
    },
}

export default SoftwareUtils;
